import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {TextField, FormControl, Stack, Snackbar, Alert, LinearProgress, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import {MetaTags} from 'react-meta-tags';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import axios from 'axios';
import Cookies from 'js-cookie';
import Tooltip from '@mui/material/Tooltip'; 
import PostSave from './PostSave'; 
import PostView from './PostView';
import PostFaqs from './PostFaqs';
import DialogAuthorization from '../components/DialogAuthorization';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';
import Header from "../pages/HeaderMy";
///import moment from 'moment';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

  
  var vertical='top',horizontal='center';
  
  export default function Execute() { 
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isBlogAdminLoggedIn');
	const childRefNewSave = React.useRef();
	const childRefView = React.useRef();
	const childRefFaq = React.useRef();
	const childRefAuthorization = React.useRef();
	const [pageLoading, setPageLoading] = React.useState(true);
	const [publishBtnFlag, setPublishBtnFlag] = React.useState(false);
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [filter, setFilter] = React.useState(false);
	const [filterFlag, setFilterFlag] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
	const [categoryId, setCategoryId] = React.useState(0);
	const [categoryList, setCategoryList] = React.useState([]);
	const [dataObj, setDataObj] = React.useState({});
	const [rows, setRows] = React.useState([]);
	const [selectedRow, setSelectedRow] = React.useState(0);
	const [authPrivileges, setAuthPrivileges] = React.useState({});
	const [postStatus, setPostStatus] = React.useState("");
	const [imgStatus, setImgStatus] = React.useState(0);
	const [ownerId, setOwnerId] = React.useState(0);
	const [channelId, setChannelId] = React.useState(0);
	
	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
  

	var myCurrentDate=new Date();
	var myPastFromDate=new Date(myCurrentDate);
    myPastFromDate.setDate(myPastFromDate.getDate() - 366);

	function hideAlert(){
		setShowAlert(false);
	}

	const columns = [
		{
			field: "Select",
			headerName: "",
			width: 90,
			sortable: false,
				renderCell: (cellValues) => {
				return (
				  <Radio 
					checked={cellValues.id === selectedRow}
					value={cellValues.id}
					name="radio-buttons"
					inputProps={{ 'aria-label': {cellValues} }}
				  />
				 )
			  }
		  },
		{ field: 'id', headerName: 'Sr. No.', width: 40 },
		{ field: 'postImage', headerName: 'Image', width: 100, renderCell: (params) =>  (
			<img src={params.row.postImageUrl+'/'+params.row.postImage} style={{height:55,margin:2}} />
		   ), },
	    { field: 'postStatus', headerName: 'Status', width: 100, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'postTitle', headerName: 'Title', width: 200, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'categoryName', headerName: 'Category Name', width: 200, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'channelName', headerName: 'Channel Name', width: 150, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'displayDate', headerName: 'Display Date', width: 100, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'publicDisplay', headerName: 'Public Display', width: 100, renderCell: (params) =>  (
			<span>{params.value===1?<>Display</>:<>Hidden</>}</span>
		   ), },   		   
	// 	{ field: 'city', headerName: 'City', width: 150, renderCell: (params) =>  (
	// 		<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
	// 	   ), },		   
	//    { field: 'state', headerName: 'State', width: 150, renderCell: (params) =>  (
	// 		<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
	// 	   ), },		   
	//    { field: 'country', headerName: 'Country', width: 150, renderCell: (params) =>  (
	// 		<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
	// 	   ), },		   
	   { field: 'tags', headerName: 'Tags', width: 200, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },		   
	   { field: 'modifiedBy', headerName: 'Modified By', width: 150, renderCell: (obj) =>  (
			<span>{obj.row.modifiedBy} {obj.row.modifiedDateTime}</span>
		   ), },
	    { field: 'createdBy', headerName: 'Created By', width: 150, renderCell: (obj) =>  (
			<span>{obj.row.createdBy} {obj.row.createdDateTime}</span>
		   ), } ,
		{ field: 'autoId', headerName: 'Auto ID', width: 150, renderCell: (obj) =>  (
			<span>{obj.value}</span>
		   ), } , 
		{ field: 'ownerId', headerName: 'Owner ID', width: 150, renderCell: (obj) =>  (
			<span>{obj.value}</span>
		   ), } ,     
   
	  ];
	

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			window.location.href='login';
		}
	}, [isloggedin]);

	React.useEffect(() => {		
		if(userObj?.obj && userObj?.obj?.loginId && userObj?.obj?.token){
			getApiData(userObj?.obj?.loginId, userObj?.obj?.token, keyword);
		}
	}, [userObj,filter]);

	async function getApiData(loginId,token,keyword){
		let axiosHeader = {
			headers:{
			  'Content-Type': 'multipart/mixed',
			  'loginId': loginId,
			  'token': token,
			  'device': 'web'
			}
		  }; 
			axios.get(env.API_URL+'/admin/posts-list?keyword='+keyword+'&categoryId='+categoryId+'&postStatus='+postStatus+'&imgStatus='+imgStatus+'&ownerId='+ownerId+'&channelId='+channelId, axiosHeader)  
			   .then(response => {
			 	////document.write("Just Checking >> "+JSON.stringify(response.data)); 
				 setPageLoading(false);
				 if(response.data && response.data.responseTxt==="InvalidToken"){ 
					Cookies.remove('isBlogAdminLoggedIn');
					window.location.href='login';
				 }else if(response.data && response.data.responseTxt==="NoAuthorization"){ 
					 childRefAuthorization.current.handleClickOpen();
				 }else if(response.data.responseTxt==="success"){
					if(response.data?.obj){					 
					  setRows(response.data.obj);
					}  
					  setAuthPrivileges(response.data.privileges);
				 }	 				
			})
	}

	React.useEffect(() => {		
		if(userObj?.obj && userObj?.obj?.loginId && userObj?.obj?.token){
			getApiDataCategories(userObj?.obj?.loginId, userObj?.obj?.token);
		}
	}, [userObj]);

	async function getApiDataCategories(loginId,token){
			let axiosHeader = {
				headers:{
				  'Content-Type': 'multipart/mixed',
				  'loginId': loginId,
				  'token': token,
				  'device': 'web'
				}
			  }; 
				axios.get(env.API_URL+'/admin/posts/category-list?sortBy=channelId,categoryName', axiosHeader)
				   .then(response => {
					////document.write("Just Checking >> "+JSON.stringify(response.data)); 
					 if(response.data && response.data.responseTxt==="InvalidToken"){ 
						Cookies.remove('isBlogAdminLoggedIn');
						window.location.href='login';
					 }else if(response.data.responseTxt==="success"){
						if(response.data?.obj){					 
						  setCategoryList(response.data.obj);
						} 
					 }	 				
				})
	}
	

	function deleteData(){
		if(dataObj && userObj?.obj && userObj?.obj?.loginId && userObj?.obj?.token){
			let axiosHeader = {
				headers:{
				  'Content-Type': 'multipart/mixed',
				  'loginId': userObj?.obj?.loginId,
				  'token': userObj?.obj?.token,
				  'device': 'web'
				}
			  }; 
	
		  const data = new FormData();
		  data.append('id', dataObj.autoId);
				 
		  axios.post(env.API_URL+'/admin/category-delete', data, axiosHeader)
				.then((response) => {
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Category has been deleted.");
			  		window.location.reload();	
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This category could not be deleted.");			
					return false;
				}
			})
				.catch((error) => {
					console.log("AXIOS ERROR: ", error);
				})	
		}		
	
		
	}

	async function getApiPublishAll(){
			let axiosHeader = {
				headers:{
				  'Content-Type': 'multipart/mixed',
				  'loginId': userObj?.obj?.loginId,
				  'token': userObj?.obj?.token,
				  'device': 'web'
				}
			  }; 

			    const data = new FormData();

				if(keyword && keyword.length>0){
					data.append('keyword', keyword);
				}
				if(categoryId && categoryId>0){
					data.append('categoryId', categoryId);
				}
				if(postStatus && postStatus.length>0){
					data.append('postStatus', postStatus);
				}
				if(imgStatus && imgStatus>0){
					data.append('imgStatus', imgStatus);
				}
				if(ownerId && ownerId>0){
					data.append('ownerId', ownerId);
				}
				if(channelId && channelId>0){
					data.append('channelId', channelId);
				}
			
			if ([...data.entries()].length > 0) {
				setPublishBtnFlag(true);
			    axios.post(env.API_URL+'/admin/posts/publish-list', data, axiosHeader)			  	  
				   .then(response => {
					setPublishBtnFlag(false);
					////document.write("Just Checking >> "+JSON.stringify(response.data)); 
					if(response.data.responseTxt==="success"){
						setSeverityAlert("success");
						setShowAlert(true);
						setAlertMessage("Done List published.");
			  			setSelectedRow(0);
						setDataObj({});
						setFilter(!filter);	
						return false;
					}else{
			  			setSeverityAlert("error");
						setShowAlert(true);
						setAlertMessage("List published could not be completed.");			
						return false;
					}	 				
				})
			}

	}

	function saveData(opt){
		if(opt===1){
			setDataObj(null);
			childRefNewSave.current.handleClickOpen();
		}else if(opt===2){	
			childRefNewSave.current.handleClickOpen();
		}else if(opt===3){	
			childRefView.current.handleClickOpen();
		}else if(opt===4){	
			childRefFaq.current.handleClickOpen();
		}
	}

	

	function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
			setDataObj(rows[obj.id-1]);
			///childRef.current.handleClickOpen();
		}
	}

	function search(){
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}
	
	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

	function reload(){
		setSelectedRow(0);
		setDataObj({});
		setFilter(!filter);
	}

	React.useEffect(() => {
		const hasFilter = (keyword && keyword.length>0) || 
		(categoryId && categoryId>0) || 
		(postStatus && postStatus.length>0) || 
		(imgStatus && imgStatus>0) || 
		(ownerId && ownerId>0) || 
		(channelId && channelId>0);

		setFilterFlag(hasFilter);

	}, [keyword,categoryId,postStatus,imgStatus,ownerId,channelId]);

	return (
		<div> 
				<MetaTags>
            		<title>Posts</title>
          		</MetaTags>
				
				<Header title="Posts" />
				{pageLoading?<LinearProgress />:null}
				<Box className='mainBox'>	

					<Box mt={1}>
							<Grid container spacing={2}>
								<Grid item md={8} xs={12}>	

									<FormControl size='small' style={{float:'left',width:100,marginRight:5}}>
										<Select
										style={{width:'100%'}}
										labelId="select-class-labela"
										id="select-classa"
										value={channelId}									
										onChange={event => setChannelId(event.target.value)}
										variant="outlined"
										>
											<MenuItem value={0} >All</MenuItem>
											<MenuItem value={1} >English</MenuItem>
											<MenuItem value={2} >Hindi</MenuItem>
										</Select>
									</FormControl>

									<FormControl size='small' style={{float:'left',width:110,marginRight:5}}>
										<Select
										style={{width:'100%'}}
										labelId="select-class-labela"
										id="select-classa"
										value={postStatus}									
										onChange={event => setPostStatus(event.target.value)}
										variant="outlined"
										>
										<MenuItem value={""} >All</MenuItem>
										<MenuItem value="Draft" >Draft</MenuItem>
										<MenuItem value="In_Review" >In_Review</MenuItem>
										<MenuItem value="Approved" >Approve</MenuItem>
										<MenuItem value="Published" >Publish</MenuItem> 
										</Select>
									</FormControl>

									<FormControl size='small' style={{float:'left',width:150,marginRight:5}}>
										<Select
										style={{width:'100%'}}
										labelId="select-class-labela"
										id="select-classa"
										value={categoryId}									
										onChange={event => setCategoryId(event.target.value)}
										variant="outlined"
										>
										<MenuItem value={0} >All</MenuItem>
										{(categoryList || []).map((obj,i)=>(
											<MenuItem key={'c'+i} value={obj.autoId} >{obj.categoryName}</MenuItem>
										))}
										</Select>
									</FormControl>

									<FormControl size='small' style={{float:'left',width:132,marginRight:5}}>
										<Select
										style={{width:'100%'}}
										labelId="select-class-labela"
										id="select-classa"
										value={imgStatus}									
										onChange={event => setImgStatus(event.target.value)}
										variant="outlined"
										>
										<MenuItem value={0} >All</MenuItem>
										<MenuItem value={1} >With Image</MenuItem>
										<MenuItem value={2} >Without Image</MenuItem>
										</Select>
									</FormControl>

									<FormControl style={{float:'left',width:125,marginRight:5}}>
										<TextField
										id="keywordtxt"
										label="Keyword for search"
										defaultValue={keyword}
										sx={{width:'100%'}}
										size="small"
										onChange={event => setKeyword(event.target.value)}
										onKeyPress={(event)=>{onEnter(event)}}
										/>
									</FormControl>

									{(userObj?.obj?.userType && userObj?.obj?.userType==1)?	
									<FormControl style={{float:'left',width:80,marginRight:5}}>
										<TextField
										id="ownertxt"
										label="Owner ID"
										defaultValue={ownerId}
										sx={{width:'100%'}}
										size="small"
										onChange={event => setOwnerId(event.target.value)}
										onKeyPress={(event)=>{onEnter(event)}}
										/>
									</FormControl>
									:null}

									<Button onClick={() => {search()}} style={{marginTop: 1}} size="small" variant="contained" color="secondary" >Search</Button>

									
								</Grid>
								<Grid item md={4} xs={12}>
									<span style={{marginTop:30}}>
											{(authPrivileges && authPrivileges.create===1)?	
												<i onClick={()=>{saveData(1)}} title="Add New" className="fa fa-plus-circle" style={{fontSize:25, color:'#0158dc',marginLeft:-15, cursor:'pointer'}} />
											:null}
										{selectedRow>0?<>

											<i onClick={()=>{saveData(3)}} title="Details" className="fa fa-info-circle" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />

											<i onClick={()=>{saveData(4)}} title="FAQ" className="fa fa-question-circle" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />

											{(authPrivileges && authPrivileges.update===1)?
												<i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
											:null}
											{(authPrivileges && authPrivileges.delete===1)?
												<i onClick={()=>{setDeleteDialogShow(true)}} title="Delete" className="fa fa-trash" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
											:null}	
										</>:null}

										{(filterFlag && userObj?.obj?.userType && userObj?.obj?.userType==1 && rows && rows.length>0 )?<>
											{publishBtnFlag?<>
												<span style={{marginLeft:10}} ><CircularProgress color="success" size={20} /> Publishing...</span>
											</>:	
											<i onClick={()=>{getApiPublishAll()}} title="Publish All" className="fa fa-check" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
  											}	
										</>:null}	
												
									</span>	
								</Grid>
							</Grid>
					</Box>

					<div className="tblReport" style={{height: '82vh', width: '100%' }}>
						<DataGrid
							rows={rows}
							columns={columns}
							pageSize={50}
							rowHeight={60}
							rowsPerPageOptions={[50]}
							ActionsComponent={()=>{alert('Hello')}}		
							style={{fontSize:12}}
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No rows found!</span>
								  </Stack>
								)}}	
							onRowClick={itm => selectRow(itm)}	
						/>
					</div>

				</Box>

			<PostSave dataObj={dataObj} reload={reload} ref={childRefNewSave} />	
			<PostView dataObj={dataObj} reload={reload} ref={childRefView} />
			<PostFaqs dataObj={dataObj} ref={childRefFaq} />
			
			<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
			</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>

			    <DialogAuthorization ref={childRefAuthorization} />

		</div>	
	);
  }